import React from 'react';
import { useNavigate } from 'react-router-dom';

interface NotFoundProps {
  title?: string;
  message?: string;
}

function NotFound({
  title = '404 - Page Not Found',
  message = 'The page you are looking for does not exist yet.',
}: NotFoundProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center gap-4 px-4">
      <h1 className="text-3xl font-semibold text-gray-900">{title}</h1>
      <p className="text-gray-600 max-w-[420px]">{message}</p>
      <button
        type="button"
        onClick={() => navigate('/')}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Go to Dashboard
      </button>
    </div>
  );
}

export default NotFound;
